import type { SupportedNudgeFeatureIds } from '../types';
import { NUDGE_FEATURE_ID_MAP } from '../types';

export const isNudgeFeatureId = (id: string): id is SupportedNudgeFeatureIds =>
  id in NUDGE_FEATURE_ID_MAP;
